<template>
  <label class="icon-box" :class="{ disabled }" @click="handleClick">
    <auth-img class="icon-img" :src="iconImg" alt="" />
    <div class="icon-label" :class="{ active: visible }">话术库</div>
  </label>
  <a-drawer
    title="话术库"
    placement="right"
    :closable="true"
    v-model:visible="visible"
    @close="closeDrawer"
    wrapClassName="commonwords-drawer"
    width="744px"
    :bodyStyle="{ padding: 0, height: 'calc(100% - 55px)' }"
  >
    <div class="z-flex content">
      <div class="left">
        <Tree @handleChange="handleChange" ref="RefTree" />
      </div>
      <div class="right">
        <div class="search-bar z-flex">
          <div class="input-area">
            <a-input
              :value="queryParam.id"
              placeholder="请输入话术ID"
              style="width: 160px"
              :allowClear="true"
              :maxlength="10"
              @input="handleInput"
            />
            <a-input
              v-model:value="queryParam.chatContent"
              placeholder="请输入话术内容"
              style="width: 200px"
              :allowClear="true"
              :maxlength="20"
            />
          </div>
          <a-button type="primary" @click="handleSearch">搜索</a-button>
        </div>
        <div class="list">
          <a-table
            class="mytable"
            :rowKey="record => record.id"
            :dataSource="dataSource"
            :columns="columns"
            :pagination="pagination"
            @change="onChangePage"
            :transformCellText="({ text }) => (text ? text : '--')"
            :customRow="click"
          />
        </div>
      </div>
    </div>
  </a-drawer>
</template>
<script setup>
import { reactive, ref, watch, defineEmits, defineExpose, defineProps, computed } from 'vue'
import { columns, paginationConfig } from './config'
import { getPageList } from '@/api/Speach/index.js'
import img from '@/assets/img/chat/commonWords.png'
import imgDark from '@/assets/img/chat/commonWordsDark.png'
import Tree from '@/views/Speech/Tree.vue'
const RefTree = ref(null)
const props = defineProps({
  disabled: { type: Boolean, default: false }
})
const emit = defineEmits(['selectWords'])
const visible = ref(false)
const dataSource = ref([])
const pagination = reactive({ ...paginationConfig })
const iconImg = computed(() => (visible.value ? img : imgDark))
const defaultQueryParam = {
  chatContent: '',
  id: null,
  classifyId: null //父类
}
const queryParam = reactive({ ...defaultQueryParam })
watch(
  () => visible.value,
  val => {
    val && initData()
  }
)
const handleClick = () => {
  if (props.disabled) return
  visible.value = !visible.value
}
const closeDrawer = () => {
  visible.value = false
}
// 话术库展示的时候获取话术
const initData = () => {
  Object.assign(pagination, paginationConfig)
  Object.assign(queryParam, defaultQueryParam)
  pageListFn()
  if (!RefTree.value) return
  RefTree.value.leftTree()
  RefTree.value.initselectedKeys()
}
//获取话术列表
const pageListFn = () => {
  const { current, pageSize } = pagination
  const params = {
    pageNo: current,
    pageSize,
    ...queryParam
  }
  getPageList(params).then(res => {
    pagination.current = res.pageNum
    pagination.pageSize = res.pageSize
    pagination.total = res.total
    dataSource.value = res.list || []
  })
}
//分类切换
const handleChange = e => {
  // 切换左侧分类后需要重置查询结果
  Object.assign(queryParam, defaultQueryParam)
  Object.assign(pagination, paginationConfig)
  if (e === -1 || !e) {
    queryParam.classifyId = null
    pageListFn()
    return
  }
  queryParam.classifyId = e
  pageListFn()
}
// 搜素话术
const handleSearch = () => {
  Object.assign(pagination, paginationConfig)
  pageListFn()
}
// 分页参数修改
const onChangePage = page => {
  pagination.pageSize = page.pageSize
  pagination.current = page.current
  pageListFn()
}
// 选择话术
const click = record => {
  return {
    onClick: () => {
      emit('selectWords', record)
    }
  }
}
defineExpose({ closeDrawer })
const handleInput = event => {
  const val = event.target.value
  queryParam.id = val.replace(/[^\d]/g, '')
}
</script>
<style lang="scss" scoped>
@import '../../index.scss';
.icon-box {
  .icon-label.active {
    color: #1890ff;
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
}

.commonwords-drawer {
  ::v-deep(.ant-drawer-content-wrapper .ant-drawer-body) {
    padding: 0;
  }
  .content {
    height: 100%;
    .left {
      max-width: 220px;
      background: #fafafa;
      border-right: 1px solid #e5e5e5;
    }
    .right {
      flex: 1;
      width: 524px;
      padding: 18px 12px;
      .search-bar {
        margin-bottom: 13px;
        .input-area {
          ::v-deep(.ant-input-affix-wrapper) {
            margin-right: 16px;
          }
        }
      }
      .list {
        height: calc(100% - 50px);
        overflow: scroll;
        .mytable {
          ::v-deep(.ant-table-tbody .ant-table-row:hover) {
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
